<template>
  <div class="b2c-new-report-wrapper ab-upgradeStyle" :class="[fromMicroDetail && 'qc-report-0']">
    <!-- 收官项目需求 区分ab（upgradeStyle） 实验结束删除多余代码  -->
    <section v-zpm="{ areaexposure: 116 }" class="qc-report">
      <div class="report-wrap">
        <!-- 收官项目：质检直播入口 -->
        <ABlive
          v-if="dataInfo.liveUrl && !fromMicroDetail"
          v-zpm="{
            sectionid: 155,
            sortid: 0,
            sortname: '质检直播入口',
            areaexposure: 155,
            legoareabackup: {
              sortName: '质检直播入口',
            },
          }"
          :omsType="dataInfo.omsType"
          @click.native="liveClick(dataInfo.liveUrl)"
        />
        <!-- 收官项目：官方验模块 -->
        <ABofficialVerification
          v-if="!fromMicroDetail"
          :showFeedback="showFeedback"
          :feedbackData="feedbackData"
          :infoData="dataInfo.report && dataInfo.report.commitmentVO"
        />
        <div v-if="dataInfo.report" class="middle-info">
          <!-- 收官项目： 验机评估报告 && 质检九宫格 -->
          <ABbaseInfo
            :dataInfo="dataInfo"
            :fromMicroDetail="fromMicroDetail"
            :omsType="dataInfo.omsType"
            @toggle="toggleCondition"
            @toggleTips="toggleTips"
          />
          <!-- 质检项区域 -->
          <qc-report
            :dataInfo="dataInfo"
            :qcCode="getQcCode"
            :fromMicroDetail="fromMicroDetail"
            :showFeedback="showFeedback"
            :feedbackData="feedbackData"
            :infoId="infoId"
            :planIds="planIds"
            :warehouseInfo="warehouseInfo"
            :cateId="Number(dataInfo.cateId || dataInfo.cateFirstId)"
            @toggle="showItem"
            @qualityTipsClick="qualityTipsClick"
          ></qc-report>
        </div>
        <ABqualityTeach
          v-if="qualityTeacherMsg && !fromMicroDetail"
          :qualityTeacherMsg="qualityTeacherMsg"
          :info="dataInfo"
          :omsType="dataInfo.omsType"
        />
      </div>

      <!-- 验机流程 -->
      <!-- <process :dataInfo="dataInfo" /> -->
      <!-- 成色弹窗 新版 含有视频解说 -->
      <rank-description
        v-if="isNewRankPopup"
        ref="rankDescription"
        brandUpgrade
        :pageId="dataInfo.pageId"
        :getContainer="fromMicroDetail ? 'body' : null"
        :qualityRatingModule="qualityRatingModule"
        :showFeedback="showFeedback"
        :feedbackData="feedbackData"
      ></rank-description>
      <!-- 成色弹窗旧版 -->
      <rank-pop v-else ref="rank" :report="dataInfo.report"></rank-pop>
      <!-- 九宫格区域验机百科弹窗 -->
      <BasePopItem ref="baseItemPop" :pageId="dataInfo.pageId" :getContainer="getContainer" />
      <!-- 质检项区域验机百科弹窗 -->
      <zz-report-pop-item
        ref="itemPop"
        :qcCode="getQcCode"
        :pageId="dataInfo.pageId"
        :cateId="Number(dataInfo.cateId)"
        :isRequest="!fromMicroDetail"
        :getContainer="getContainer"
      />
      <!-- 电池解释弹窗 -->
      <common-popup
        :show="showPopup"
        :headMsg="headMsg"
        :getContainer="getContainer"
        @close="close"
      >
        <battery-popup
          :id="explainInfo.id"
          :explainTexts="explainInfo.explainTexts"
          :showFeedback="showFeedback"
          :feedbackData="feedbackData"
        ></battery-popup>
      </common-popup>
    </section>

    <!-- 温馨提示 -->
    <warm-tips
      v-if="qualityTipsMsg && Object.keys(qualityTipsMsg).length"
      :qualityTipsMsg="qualityTipsMsg"
    />
  </div>
</template>
<script>
  import native from '@zz-common/native-adapter'
  import { setPicSize } from '@zz-common/zz-utils'
  import { getExplain, getReportInfoByOrder } from '../../apis/index'
  import RankDescription from '../../rank-description'
  import RankPop from '../../rank-pop'
  import BasePopItem from './base-pop-item'
  import QcReport from './qc-report'
  import Process from './process'
  import warmTips from './warm-tips'
  import ZzReportPopItem from './zz-report-pop-item'
  import commonPopup from './common-popup'
  import BatteryPopup from './battery-popup'

  import ABlive from './ABlive'
  import ABofficialVerification from './ABofficial-verification'
  import ABbaseInfo from './ABbase-info'
  import ABqualityTeach from './ABquality-teach'
  export default {
    name: 'zz-new-report',
    components: {
      RankDescription,
      RankPop,
      BasePopItem,
      QcReport,
      Process,
      warmTips,
      ZzReportPopItem,
      commonPopup,
      BatteryPopup,
      ABlive,
      ABofficialVerification,
      ABbaseInfo,
      ABqualityTeach,
    },
    props: {
      Infos: {
        type: Object,
        default: () => {},
      },
      omsSkuId: {
        type: String,
        default: '',
      },
      infoId: {
        type: String,
        default: '',
      },
      warehouseInfo: {
        type: String,
        default: '',
      },
      orderId: {
        type: String,
        default: '',
      },
      infoLv: {
        type: Object,
        default: () => {},
      },
      fromMicroDetail: {
        type: Boolean,
        default: false,
      },
      showFeedback: {
        type: Boolean,
        default: false,
      },
      feedbackData: {
        type: Object,
        default: () => {},
      },
      getContainer: {
        type: [String, Object],
        default: null,
      },
      planIds: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        dataInfo: {},
        showPopup: false,
        explainInfo: {},
      }
    },
    computed: {
      headMsg() {
        const { head: title = '', subHead: text = '' } = this.explainInfo
        return {
          title,
          text,
        }
      },
      qualityTeacherMsg() {
        const { qcUser = {} } = this.dataInfo.report || {}
        if (Object.keys(qcUser).length > 0) {
          return qcUser
        }
        return ''
      },

      qualityTipsMsg() {
        const { tips = [] } = this.dataInfo.report || {}
        return tips
      },
      $setPicSize() {
        return setPicSize
      },
      qualityRatingModule() {
        return (this.dataInfo.report && this.dataInfo.report.conditionIntro) || {}
      },
      isNewRankPopup() {
        const { finenessLevelValueId, finenessDialogContents } = this.qualityRatingModule
        return !!(finenessDialogContents || []).find(
          ({ valueId }) => valueId === finenessLevelValueId
        )
      },
      getQcCode() {
        return this.dataInfo.report && this.dataInfo.report.qcCode
      },
    },
    created() {
      this.getReportData()
    },

    methods: {
      //直播链接跳转
      liveClick(url) {
        const UA = navigator.userAgent
        // 采货侠
        if (/zzhunter$/g.test(UA)) {
          this.$emit('live', url)
        } else {
          url &&
            native.skipToUrl({
              targetUrl: url,
            })
        }
      },
      toggleCondition() {
        //this.$refs.rank.togglePopup()
        if (this.isNewRankPopup) {
          this.$refs.rankDescription.togglePopup()
        } else {
          this.$refs.rank.togglePopup()
        }
      },
      /**
       * $ 九宫格百科弹窗
       */
      toggleTips(data) {
        if (this.fromMicroDetail) {
          this.$refs.baseItemPop.togglePopup(data)
        } else {
          const _data = {
            ...data,
            name: data.key, //质检标题
            smallEncyclopediaPic: (data.qcWiki && data.qcWiki.qcWikiImg) || '', // $ 质检小图标
            from: 'nine', // 来源，质检九宫格
          }
          this.$refs.itemPop.togglePopup(_data)
        }
      },
      /**
       * $ 质检报告二级质检项百科弹窗
       */
      showItem(data) {
        const _data = {
          ...data,
          from: 'quality',
        }
        this.$refs.itemPop.togglePopup(_data)
      },
      /**
       * $ 获取质检报告信息
       */
      getReportData() {
        //没有从父组件传质检报告信息, 通过omsSkuid从接口获取
        if (!this.Infos || Object.keys(this.Infos).length == 0 || !this.Infos.report) {
          const { omsSkuId, infoId, orderId, pageId, cateId } = this.Infos ? this.Infos : {}
          if (omsSkuId || infoId || orderId) {
            getReportInfoByOrder({
              omsSkuId,
              orderId,
              infoId,
            }).then((res) => {
              this.dataInfo = {
                report: res.data,
                liveUrl:
                  'https://m.zhuanzhuan.com/u/online-activities/live/index.html?needHideHead=3&bgARGB=FF000000',
                infoLv: this.infoLv || {},
                pageId,
                cateId,
              }
            })
          }
        } else {
          // 从父组件传数据过来
          this.dataInfo = this.Infos || {}
          console.log('dataInfo', this.dataInfo)
        }
      },
      async qualityTipsClick({ isPoup, titleId }) {
        const result = await getExplain({
          request: titleId,
        })
        const { data = {} } = result
        if (Object.keys(data).length > 0) {
          this.showPopup = isPoup
          this.explainInfo = data
        }
      },
      close() {
        this.showPopup = false
      },
    },
  }
</script>

<style lang="scss">
  @import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';
  .b2c-new-report-wrapper {
    min-height: 500px;
    overflow: hidden;
    padding-top: 30px;
    .qc-report {
      font-size: 24px;
      padding: 60px 32px;
      padding-top: 40px;
      background: #ffffff;
      line-height: 1;
    }

    &.qc-report-0 {
      padding: 0;
      .qc-report {
        padding: 0;
      }
      .report-wrap {
        padding-top: 20px !important;
      }
    }

    .report-wrap {
      position: relative;
      padding-bottom: 20px;
      background: #fafafa;
      border-radius: 0 0 24px 24px;
      .middle-info {
        position: relative;
        z-index: 1;
        background-size: 100%;
        padding: 0 20px;
        border-radius: 4px;
      }
    }
  }
  .ab-upgradeStyle {
    .qc-report {
      padding: 0 !important;
      margin: 0 32px !important;
      background-image: url(https://pic2.zhuanstatic.com/zhuanzh/b4c6c69f-026e-417a-9ab8-64a3a03c59e9.png) !important;
      background-size: 100% 68px !important;
      background-repeat: repeat-y !important;
      background-color: transparent !important;
      overflow: hidden;
      border-radius: 20px 20px 16px 16px !important;
    }
    .report-wrap {
      padding-bottom: 16px;
      background: transparent !important;
      .middle-info {
        padding: 0 12px !important;
        position: static;
      }
    }
    .report_person {
      border-radius: 8px 8px 0 0 !important;
    }
    .new-qc-report-detail {
      margin-top: -14px !important;
      border-radius: 0 0 8px 8px !important;
      padding: 0 32px 31px !important;
    }
    .quality-content {
      border-radius: 0 !important;
    }
    .report-tab-tt {
      margin-bottom: 4px !important;

      .con {
        font-family: PingFangSC-Regular, PingFang SC;
      }
    }

    .b2c-teacher-wrapper {
      height: 108px !important;
      padding: 0 34px 0 44px !important;
      .teacher-company {
        align-items: flex-start;
        img {
          position: absolute;
          top: 8px !important;
          right: 0 !important;
          width: 104px !important;
          height: 104px !important;
          margin-right: 44px !important;
          opacity: 0.8 !important;
        }
      }
    }
  }
</style>
